import React from 'react';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';
import { normalizeMoney } from '../../utils/util';
import history from '../../config/history';

import { updateQtyFromCart, removeProductFromCart } from '../../store/ducks/cart';

const Container = styled.div`
  width: 95%;
  padding: 2% 5%;
  margin: 8px;
  background: #ccc;
  border-radius: 10px;

  display: flex;
  align-items: center;
  justify-content: space-between;

  .product-description {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  img {
    width: 136px;
    height: 136px;
    border-radius: 10px;
    margin-bottom: 16px;
  }

  .product-information {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .amount button {
    font-size: 16px;
    margin: 16px;

    @media (max-width: 768px) {
      margin: 15px;
      width: 50px;
      height: 50px;
      padding: 1px;
    }
  }

  .removeButton {
    font-size: 16px;
    height: 48px;
  }
`;

function ProductCard({ product, qty, index }) {
  const dispatch = useDispatch();

  return (
    <Container>
      <div className="product-description" />
      <div className="product-information">
        <img src={product.pictures[0]} alt="Card cap" />
        <h5>{product.name.toUpperCase()}</h5>
        <p>Descrição: {product.description.substr(0, 50)}...</p>
        <p>Preço: {normalizeMoney(product.price)}</p>
        <p>Frete: R$ 10,00</p>
        <span>Quantidade</span>
        <div className="amount">
          <button
            onClick={() => {
              dispatch(updateQtyFromCart(index, qty - 1));
            }}>
            -
          </button>
          <span>{qty}</span>
          <button
            onClick={() => {
              dispatch(updateQtyFromCart(index, qty + 1));
            }}>
            +
          </button>
        </div>
      </div>
      <button
        className="removeButton"
        onClick={() => {
          dispatch(removeProductFromCart(index));
          setTimeout(() => history.push('/'), 250);
        }}>
        Remover
      </button>
    </Container>
  );
}

export default ProductCard;
